import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
// import FindmypensionImg from "../../assets/PensionProduct/Findmypension.png";
import ReviewMyPensionImg from "../../assets/PensionProduct/reviewmypension.png";
import AccessMyPensionImg from "../../assets/PensionProduct/accessmypension.png";
import StartNewPensionImg from "../../assets/PensionProduct/Startanewpension.jpg";
import FindConsolidateImg from "../../assets/PensionProduct/findandconsolidatepension.png";
import MaximisePensionImg from "../../assets/PensionProduct/maximisepension.png";
import InternationalTransferImg from "../../assets/PensionProduct/internationaltransfer.png";
import { Helmet } from "react-helmet-async";
import "./Pension.css";

const Pension: React.FC = () => {
  const pensionInfo = {
    // "Find My Pension": {
    //   description: "Not sure where your pension is? Use our Find My Pension tool to track it down and take control of your retirement savings! Our advanced search feature connects with multiple providers to locate lost pensions, offering a comprehensive report to help you consolidate and optimize your funds.",
    //   img: FindmypensionImg
    // },
    "Review My Pension": {
      description:
        "Take control of your future with our Review My Pension service. Assess performance, adjust contributions, and plan confidently for retirement! Get a detailed analysis of your current plan, including growth projections, fee comparisons, and personalised recommendations from our advisors.",
      img: ReviewMyPensionImg,
    },
    "Access My Pension": {
      description:
        "Looking to withdraw from your pension? Use our Access My Pension service for a smooth and hassle-free process! Choose from flexible withdrawal options, including lump sums or regular payments, with real-time guidance on tax implications and long-term impacts on your retirement income.",
      img: AccessMyPensionImg,
    },
    "Start a New Pension": {
      description:
        "Ready to start saving for retirement? Use our Start a Pension feature to kick off your journey today! Benefit from tailored investment options, tax incentives, and a step-by-step setup process guided by our financial experts to build a robust retirement foundation.",
      img: StartNewPensionImg,
    },
  };

  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate("/contact/");
    setTimeout(() => {
      const element = document.getElementById("get-in-touch");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
      },
    },
  };

  const fadeInVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.8 } },
  };

  const [heroRef, heroInView] = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <div className="product-pension">
      <Helmet>
        <title>
          Pension & Retirement - Apollo Financial Services | Apollo Financial
          Services Ireland
        </title>
        <meta
          name="description"
          content="Expert pension planning services in Ireland. Pension reviews, consolidation, tax-efficient strategies and retirement planning from regulated advisors."
        />
        <meta
          name="keywords"
          content="how much do I need to retire Ireland, top budgeting tips for 2025, should I invest in index funds, understanding ETFs in Ireland, is now a good time to invest, compound interest calculator Ireland, difference between pension and PRSA, what is AVC pension Ireland, how to grow your net worth, monthly saving plan examples, how much does a financial advisor cost in Ireland, what services do financial planners offer, when should I hire a financial advisor, is financial advice tax deductible in Ireland, how to get started with investing, is pension income taxed in Ireland, what’s the best pension plan for me, how much should I save each month, what’s the difference between savings and investments, can a financial advisor help with debt, is it too late to start a pension at 50, what does wealth management include, how to pass on wealth tax-free, what happens to pension when you die, how does inheritance tax work in Ireland, can I take out my pension early, how are investments taxed in Ireland, what is capital gains tax Ireland, what’s a good financial plan, should I use a financial advisor or do it myself, how often should I meet with my advisor, how to switch financial advisors, are financial advisors regulated in Ireland, do I need financial advice before marriage, how do financial advisors make money, do I need life insurance in my 30s, how to plan for college tuition, can I claim pension tax relief, who inherits your pension, can I split pension with spouse, does a PRSA expire, is a pension better than a savings account, what insurance should I get in my 40s, when should I start investing for retirement, what’s the best retirement age, do I pay tax on savings interest, who offers the best pension rates in Ireland, what’s the safest way to invest money, do I need a will or an estate plan, how do I know if I’m financially secure"
        />
        <meta
          property="og:title"
          content="Pension & Retirement - Apollo Financial Services"
        />
        <meta
          property="og:description"
          content="Expert pension planning services in Ireland. Pension reviews, consolidation, and tax-efficient strategies."
        />
        <link rel="canonical" href="https://www.apollofinancial.ie/pension/" />
      </Helmet>

      {/* Add Structured Data */}
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "FinancialService",
            "name": "Apollo Financial Services Pension Planning",
            "description": "Professional pension and retirement planning services in Ireland",
            "url": "https://www.apollofinancial.ie/pension/",
            "serviceType": "Pension Planning",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Thomastown House, Thomastown",
              "addressLocality": "Duleek",
              "addressRegion": "Co. Meath",
              "postalCode": "A92 X362",
              "addressCountry": "IE"
            },
            "offers": {
              "@type": "Offer",
              "name": "Pension Services",
              "description": "Comprehensive pension services including reviews, consolidation, and retirement planning",
              "url": "https://www.apollofinancial.ie/pension"
            },
            "provider": {
              "@type": "Organization",
              "name": "Apollo Financial Services",
              "sameAs": [
                "https://www.facebook.com/ApolloFinancialServicesLtd",
                "https://www.linkedin.com/company/apollo-financial-services-limited/"
              ]
            }
          }
        `}
      </script>
      {/* Hero Section */}
      <motion.section
        ref={heroRef}
        className="product-pension-hero"
        initial="hidden"
        animate={heroInView ? "visible" : "hidden"}
        variants={fadeInVariants}
      >
        <div className="hero-overlay"></div>
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate={heroInView ? "visible" : "hidden"}
        >
          <motion.h1 variants={itemVariants}>
            Pension & Retirement Planning
          </motion.h1>
          <motion.p variants={itemVariants}>
            Secure your financial future with expert retirement strategies
            tailored to your needs and lifestyle.
          </motion.p>
        </motion.div>
      </motion.section>

      {/* Call to Action Section */}
      <div className="product-pension-actions">
        {Object.entries(pensionInfo).map(
          ([title, { description, img }], index) => {
            return (
              <div
                className={`pension-action-section ${
                  index % 2 === 0 ? "text-left" : "text-right"
                }`}
                key={title}
              >
                <div className="pension-action-content">
                  <h2>{title}</h2>
                  <p>{description}</p>
                  <button
                    className="pension-action-btn"
                    onClick={handleRedirect}
                  >
                    Find Out More →
                  </button>
                </div>
                <div className="pension-action-image">
                  <img src={img} alt={title} />
                </div>
              </div>
            );
          }
        )}
      </div>

      {/* Why Pension Planning Matters Section */}
      <section className="product-pension-content">
        <div className="product-pension-intro">
          <h2>Why Pension Planning Matters</h2>
          <p>
            A well-structured pension plan is the cornerstone of financial
            independence in retirement. Our advisors help you optimise
            savings, access lump sums, explore early retirement options, ensure
            tax efficiency, and provide long-term financial stability.
          </p>
        </div>

        <div className="product-pension-services">
          <div className="product-pension-service-item">
            <img
              src={FindConsolidateImg}
              alt="Pension Consolidation"
              className="product-pension-service-image"
            />
            <div className="product-pension-service-content">
              <h3>Find & Consolidate Pensions</h3>
              <p>
                ✔ We help you track down lost or old pensions and consolidate
                them into a single, high-performing plan.
              </p>
            </div>
          </div>

          <div className="product-pension-service-item product-pension-reverse">
            <img
              src={MaximisePensionImg}
              alt="Pension Growth"
              className="product-pension-service-image"
            />
            <div className="product-pension-service-content">
              <h3>Maximise Your Pension Growth</h3>
              <p>
                ✔ Unlock the potential of your pension with expert investment
                strategies.
              </p>
            </div>
          </div>

          <div className="product-pension-service-item">
            <img
              src={InternationalTransferImg}
              alt="Pension Transfer"
              className="product-pension-service-image"
            />
            <div className="product-pension-service-content">
              <h3>International & Domestic Transfers</h3>
              <p>
                ✔ Seamlessly transfer pensions between providers or from
                overseas accounts with our expert guidance.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="product-pension-why">
        <h2>Why Choose Our Pension Services?</h2>
        <div className="product-pension-features">
          <div className="product-pension-feature-item">
            <h3>Expert Guidance</h3>
            <p>
              As a regulated firm, authorised by the Central Bank of Ireland,
              our qualified financial advisors create tailored pension plans
              designed to help you achieve your retirement goals with
              confidence..
            </p>
          </div>
          <div className="product-pension-feature-item">
            <h3>Tax-Efficient Strategies</h3>
            <p>Maximise your savings with tailored tax-efficient options.</p>
          </div>
          <div className="product-pension-feature-item">
            <h3>Flexible Withdrawal Options</h3>
            <p>
              Choose from lump sums, regular payments, or phased withdrawals to
              match your lifestyle.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Pension;
